module.exports = __webpack_public_path__ + "assets/img/36_1441.78802cf2.jpg";